import LegalLayout from "@/components/LegalLayout";

const Block = ({ heading, children }) => (
  <div>
    <h2 className="font-display uppercase tracking-wide text-xl text-white mb-3">{heading}</h2>
    <div className="space-y-1">{children}</div>
  </div>
);

export default function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <p className="text-sm text-white/45">
        Informationspflicht laut § 5 E-Commerce-Gesetz (ECG), § 14 Unternehmensgesetzbuch (UGB),
        § 63 Gewerbeordnung (GewO) und Offenlegungspflicht laut § 25 Mediengesetz.
      </p>

      <Block heading="Medieninhaber &amp; Diensteanbieter">
        <p className="text-white font-semibold">VPT Operations GmbH</p>
        <p>Römerweg 1c</p>
        <p>8434 Tillmitsch</p>
        <p>Österreich</p>
      </Block>

      <Block heading="Kontakt">
        <p>Ansprechpartner: Buchhaltung</p>
        <p>
          E-Mail:{" "}
          <a href="mailto:tuningfiles@vmaxx.at" className="text-primary hover:underline">
            tuningfiles@vmaxx.at
          </a>
        </p>
        <p>WhatsApp: +43 664 9203284</p>
      </Block>

      <Block heading="Unternehmensdaten">
        <p>UID-Nummer: ATU81130447</p>
        <p>Unternehmensgegenstand: Automotive Software Solutions &amp; Engineering – Chiptuning Fileservice</p>
      </Block>

      <Block heading="Aufsichtsbehörde / Gewerbebehörde">
        <p>Bezirkshauptmannschaft Leibnitz</p>
        <p>Mitgliedschaft: Wirtschaftskammer Steiermark</p>
        <p>Berufsrecht: Gewerbeordnung (www.ris.bka.gv.at)</p>
      </Block>

      <Block heading="EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          . Unsere E-Mail-Adresse findest du oben im Impressum.
        </p>
        <p className="text-white/45 text-sm mt-2">
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Block>

      <Block heading="Haftung für Inhalte &amp; Links">
        <p>
          Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Für
          verlinkte externe Inhalte, auf deren Gestaltung wir keinen Einfluss haben, wird keine
          Haftung übernommen. Für den Inhalt der verlinkten Seiten sind ausschließlich deren
          Betreiber verantwortlich.
        </p>
      </Block>

      <Block heading="Urheberrecht">
        <p>
          Sämtliche Inhalte dieser Website (Texte, Bilder, Grafiken, Logo) unterliegen dem
          Urheberrecht. Eine Verwertung außerhalb der Grenzen des Urheberrechts bedarf der
          schriftlichen Zustimmung der VPT Operations GmbH.
        </p>
      </Block>
    </LegalLayout>
  );
}
